class WelcomeMessage extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.textContent = this.showWelcomeMessage()

    this.userLoggedOut = this.userLoggedOut.bind(this)

    this.userLoggedOut()
  }

  userLoggedOut () {
    const urlParams = new URLSearchParams(window.location.search)
    const logoutParam = urlParams.get('return_url')

    if (logoutParam === '/account') {
      const entries = performance.getEntriesByType('navigation')
      entries.forEach(entry => {
        if (entry.type === 'reload') {
          this.setAttribute('aria-hidden', false)
          this.externalEls.logout.element.setAttribute('aria-hidden', true)
        } else {
          this.setAttribute('aria-hidden', true)
          this.externalEls.logout.element.setAttribute('aria-hidden', false)
        }
      })
    }
  }

  showWelcomeMessage () {
    const tDate = new Date()

    const currentTime = tDate.toLocaleTimeString({
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    })

    if (currentTime > '06:00:00' && currentTime < '12:00:00') {
      return `${window.theme.strings.goodMorning}`
    } else if (currentTime > '12:00:00' && currentTime < '18:00:00') {
      return `${window.theme.strings.goodAfternoon}`
    } else if (currentTime > '18:00:00') {
      return `${window.theme.strings.goodEvening}`
    } else {
      return `${window.theme.strings.welcome}`
    }
  }
}

if (!customElements.get('welcome-message')) {
  customElements.define('welcome-message', WelcomeMessage)
}
